/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteUserApiKey} from '../api'

export const useMutationDeleteUserApiKey = createReactQueryMutationHook('deleteUserApiKey', deleteUserApiKey)
